"use client"

import React from "react"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { DialogTitle } from "@radix-ui/react-dialog"
import { Zap, ArrowRight, Check } from "lucide-react"

interface UpgradeModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onSignup: () => void
}

export const UpgradeModal: React.FC<UpgradeModalProps> = ({
  open,
  onOpenChange,
  onSignup,
}) => {
  const benefits = [
    "Unlimited questions to review more code, faster",
    "Instant, actionable fixes to ship with confidence",
    "Priority access to new features and models",
  ]

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[480px] bg-[#0a1628] p-0 border border-[#1e3a5f] shadow-2xl overflow-hidden [&>button]:text-gray-300 [&>button]:hover:text-white [&>button]:top-6 [&>button]:right-5">
        {/* Top accent */}
        <div className="h-1.5 bg-gradient-to-r from-[#3BCF8E] to-[#2DA771]" />
        
        <div className="px-8 py-8">
          <DialogHeader className="space-y-4">
            {/* Icon with glow */}
            <div className="flex justify-center">
              <div className="h-16 w-16 rounded-2xl bg-gradient-to-br from-[#3BCF8E] to-[#2DA771] flex items-center justify-center shadow-[0_0_30px_rgba(59,207,142,0.3)]">
                <Zap className="h-8 w-8 text-white" />
              </div>
            </div>
            
            {/* Title with code brackets */}
            <DialogTitle className="text-2xl font-bold text-center text-white">
              <span className="text-[#3BCF8E]">&lt;</span>
              {" "}Unlock Full Access{" "}
              <span className="text-[#3BCF8E]">/&gt;</span>
            </DialogTitle>
            
            <DialogDescription className="text-center text-gray-400 text-base">
              Get the most out of AI-powered code exploration
            </DialogDescription>
          </DialogHeader>

          {/* Benefits card */}
          <div className="mt-8 rounded-xl border border-[#1e3a5f] bg-[#0d1f35] p-5 space-y-4">
            {benefits.map((item) => (
              <div key={item} className="flex items-center gap-3">
                <div className="h-5 w-5 rounded-full bg-[#3BCF8E]/20 flex items-center justify-center shrink-0">
                  <Check className="h-3 w-3 text-[#3BCF8E]" />
                </div>
                <span className="text-gray-300 text-sm">{item}</span>
              </div>
            ))}
          </div>

          <DialogFooter className="flex-col !justify-center items-center gap-4 pt-8">
            <Button
              onClick={onSignup}
              className="h-12 text-base font-semibold bg-[#3BCF8E] hover:bg-[#2DA771] text-white shadow-[0_0_20px_rgba(59,207,142,0.4)] hover:shadow-[0_0_30px_rgba(59,207,142,0.6)] transition-all"
              size="lg"
            >
              Start Free Trial
              <ArrowRight className="h-5 w-5" />
            </Button>
            
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  )
}
